import React from 'react';
import { useSelector } from 'react-redux';

function TableContent({ headers }) {
  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { dimensionList } = vehicleTrackingReducer;
  return (
    <tbody>
      {dimensionList && dimensionList?.length > 0 ? (
        dimensionList.map((dimensionObj) => (
          <tr key={dimensionObj.id}>
            {headers.map((header) => (
              <td className="table-data" key={header.value}>
                <div className="div-flex-row">
                  {header.value === 'data_type' ? (
                    <span>{dimensionObj?.data_type.name}</span>
                  ) : header.value === 'unit_measurement' ? (
                    <span>{dimensionObj?.unit_measurement.name}</span>
                  ) : (
                    <span>{dimensionObj[header.value]}</span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={headers?.length} className="no-data-found border-bottom">
            <span className="text-sm">No Dimensions Created</span>
          </td>
        </tr>
      )}
    </tbody>
  );
}

export default TableContent;
